import { createApp } from 'vue'
import { createPinia } from 'pinia'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueFullscreen from 'vue-fullscreen'

import '@/apps/traforama/icons'

import ElementPlus from 'element-plus'
import 'normalize.css/normalize.css'
import 'element-plus/dist/index.css'
import '@/apps/traforama/styles/index.scss'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { VueCsvImportPlugin } from 'vue-csv-import'

import App from '@/apps/traforama/App.vue'
import router from '@/apps/traforama/router'

import useLoading from '@/hooks/useLoading'
import useTracking from '@/hooks/useTracking'
import useErrorLogger from '@/hooks/useErrorLogger'

import { reloadOnChunkError } from '@/support/chunkReload'

import appEnv from '@/support/env'

if (typeof String.prototype.replaceAll === 'undefined') {
  // eslint-disable-next-line
  String.prototype.replaceAll = function(match, replace) {
    // @ts-ignore:next-line
    return this?.replace(new RegExp(match, 'g'), () => replace)
  }
}
// @ts-ignore:next-line
const app = createApp(App)
const pinia = createPinia()
app.use(ElementPlus)
app.use(pinia)
app.use(router)
app.use(VueFullscreen)
app.use(VueCsvImportPlugin)

app.component('FontAwesomeIcon', FontAwesomeIcon)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(`${key}ElementIcon`, component)
}

useLoading(router)
useTracking(router, app, 'TraforamaApp')
// Before the router runs: the first navigation is where a stale tab meets a chunk that
// no longer exists, and this is what turns that dead end into one reload.
reloadOnChunkError()

useErrorLogger(router, appEnv.SENTRY_DSN, app)

app.mount('#app')
